import * as z from 'zod';
import { zZipCode } from '../error-messages';

export const updateZipCodeFormSchema = z.object({
  zipCode: zZipCode,
});

export type UpdateZipCodeForm = z.TypeOf<typeof updateZipCodeFormSchema>;
